<template>
  <div style="position: absolute;top: 50px">
    <div class="card-container">
      <div v-for="device in devices" :key="device.equ_id" class="el-card" style="display: flex; justify-content: center;align-items: center;
    margin-bottom: 10px;width: 300px;height: 310px;border: 1px solid gainsboro;" @click="deviceInformation(device.equ_id,$event)">
        <div>
          <img class="kt1" v-if="device.equ_name.includes('水泵')" src="../assets/img/shuibeng.jpg" alt="水泵" />
          <img class="kt2" v-else-if="device.equ_name.includes('风机')" src="../assets/img/fengji.jpg" alt="风机" />
          <el-button id="kt-button">
          </el-button>
        </div>
        <span style="font-size: 14px;position: absolute;top: 160px">{{ device.equ_name }}</span>
        <div class="buttonC">
          <el-button class="a"><span id="all">改前耗电:<span style="color: blue">{{ device.pre_mod_power_con }}</span></span></el-button>
          <el-button class="b"><span id="all">改后耗电:<span style="color: blue">{{ device.post_mod_power_con }}</span></span></el-button>
          <el-button class="c"><span id="all">累计节省电能:<span style="color: blue">{{ device.cumulative_power_savings }}</span></span></el-button>
          <el-button class="d"><span id="all">实时节电率:<span style="color: red">{{ device.realtime_power_sr }}</span></span></el-button>
          <el-button class="e"><span id="all">近一天最高节电率:<span style="color: red">{{ device.highest_daily_power_sr}}</span></span></el-button>
          <el-button class="f"><span id="all">近一天平均节电率:<span style="color: red">{{ device.average_daily_power_sr }}</span></span></el-button>
        </div>
      </div>
    </div>
    <!--设备参数详细列表-->
    <div v-for="device in devices" :key="device.equ_id">
      <el-dialog :visible.sync="dialogFormVisible[device.equ_id]" width="420px">
        <span slot="title" class="custom-dialog-title">设备节能详细参数</span>
        <el-form ref="form" :model="form" style="width: 500px;margin-top: 10px">
          <div class="d-input">
            <el-form-item label="改前耗电:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.pre_mod_power_con" autocomplete="off" readonly></el-input>
            </el-form-item >
            <el-form-item label="改后耗电:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.post_mod_power_con" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="累计节省电能:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.cumulative_power_savings" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="实时节电率:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.realtime_power_sr" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="近一天最高节电率:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.highest_daily_power_sr" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="近一天平均节电率:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.average_daily_power_sr" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="节能累计运行时长:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.es_cumulative_runtime" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="非节能状态累计耗电:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.non_es_cumulative_power_con" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="非节能状态累计时长:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.non_es_cumulative_duration"  autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="电表号:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.meter_number" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="电表读数:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.meter_reading" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="历史数据:" :label-width="formLabelWidth" size="mini">
              <el-button size="mini" type="success" @click="showHistoryDialog(device.equ_id)">查看历史数据</el-button>
            </el-form-item>
            <el-form-item label="实时耗电曲线:" :label-width="formLabelWidth" size="mini">
              <el-button size="mini" type="success" @click="showCard(device.equ_id)">查看耗电曲线</el-button>
            </el-form-item>
            <el-form-item label="远程启停:" :label-width="formLabelWidth" size="mini">
              <el-button size="mini" type="primary" @click="open(device.equ_id)">启动</el-button>
              <el-button size="mini" type="danger" @click="close(device.equ_id)">停止</el-button>
            </el-form-item>
            <el-form :model="form" :rules="rules" ref="form" @keyup.native="validateInput">
              <el-form-item :rules="rules.update_f" prop="update_f" label="手动设定频率:" :label-width="formLabelWidth" size="mini" >
                <el-input v-model="form.update_f" autocomplete="off" placeholder="请输入频率"></el-input>
                <el-button size="mini" type="primary" style="position: absolute" @click="() =>sure(device.equ_id)">修改</el-button>
              </el-form-item>
            </el-form>
            <el-form-item :rules="rules" prop="update_f" label="实时频率:" :label-width="formLabelWidth" size="mini">
              <el-input v-model="form.realtime_frequency" autocomplete="off" readonly></el-input>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
    </div>
    <!--查看历史数据嵌套的表格-->
    <div>
      <el-dialog title="历史数据" :visible.sync="dialogTableVisible">
        <el-table :data="gridData" style="height: auto;">
          <el-table-column property="times" label="日期" width="150"></el-table-column>
          <el-table-column property="realtime_es" label="实时节电率" width="150"></el-table-column>
          <el-table-column property="meter_real_reding" label="实时电表读数"></el-table-column>
          <el-table-column property="vfd_runtime" label="运行时长"></el-table-column>
          <el-table-column property="cumulative_power_savings" label="累计节约电能"></el-table-column>
        </el-table>
        <el-button @click="downloadExcel" style="position: absolute;top: 10px;left: 580px" type="success">下载 Excel</el-button>
      </el-dialog>

    </div>
    <!--查看耗电曲线-->
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%">
      <div style="height: 100px">
        <!--这个echarts 图表在el-card里面改 才有效果-->
        <el-card style="height: 550px;width: 900px;position: relative;top: -120px;left: -200px">
          <div class="chart-container" id="line" style="width: 800px;height: 500px"></div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from "echarts";
import index from "vuex";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import GoToDeviceManagementUtil from "../util/goToDeviceManagementUtil";
export default {
  name: "Card",
  computed: {
    index() {
      return index
    }
  },
  data(){
    return{
      line:false,
      option : {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: '耗电曲线'
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          data: ['实施功率', '额定功率',]
        },
        xAxis: {
          type: 'category',
          //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          data:[]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '实施功率',
            type: 'line',
            data: [],
            smooth: true
          },
          {
            name: '额定功率',
            type: 'line',
            data: [],
            smooth: true
          },
        ]
      },
      gridData: ['日期', '实时节电率', '实时电表读数', 'VFD运行时间', '累计节电量'],// 你的表格数据
      dialogVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false, // 使用数组来管理参数详细列表的显示状态
      formLabelWidth: '145px',
      form: {
        pre_mod_power_con:'',//改前耗电
        post_mod_power_con:'',//改后耗电
        cumulative_power_savings:'',//累计节省电能
        realtime_power_sr:'',//实时节电率
        highest_daily_power_sr:'',//近一天最高节电率
        average_daily_power_sr:'',//近一天平均节电率
        es_cumulative_runtime:'',//节能累计运行时长
        non_es_cumulative_power_con:'',//非节能状态累计耗电
        non_es_cumulative_duration:'',//非节能状态累计时长
        meter_number:'',//电表号
        meter_reading:'',//电表读数
        update_f:'',//手动设定频率
        realtime_frequency:'',//实时频率
      },
      equ_id:'',
      equ_name:'',// 设备名称
      devices: [],// 将设备信息存储到这个数组中
      rules: {
        update_f: [
          { required: true, message: '请填写频率', trigger: 'blur' },
          { validator: this.validateNumber, trigger: 'change' }
        ]
      }
    }
  },
  // 在 Card 页面中从路由参数中获取数据
  mounted() {
    console.log('query'+this.$route.query)
    console.log('devices'+this.devices)
  },
  methods:{
    validateNumber(rule, value, callback) {
      if (value && !/^\d*$/.test(value)) {
        callback(new Error('请输入数字'));
      } else {
        callback();
      }
    },
    validateInput(event) {
      const input = event.target.value;
      if (input && !/^\d*$/.test(input)) {
        this.$message.error('请输入数字');
        this.form.update_f = input.replace(/[^\d]/g, ''); // 移除非数字字符
      }
    },
    //下载历史数据execl
    downloadExcel() {
      // 定义中文标题和英文标题对应关系
      const titleMap = {
        times: '时间',
        realtime_es: '实时电力消耗',
        meter_real_reding: '仪表实际读数',
        vfd_runtime: 'VFD运行时间',
        cumulative_power_savings: '累计节电量'
      };

      // 将数据对象的键转换为英文标题
      const englishGridData = this.gridData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (key in titleMap) {
            newItem[titleMap[key]] = item[key];
          } else {
            newItem[key] = item[key];
          }
        }
        return newItem;
      });

      // 生成 Excel 表格
      const ws = XLSX.utils.json_to_sheet(englishGridData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      // 下载 Excel 文件
      saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '历史记录_data.xlsx');
    },

    //查看全部历史数据
    showHistoryDialog(equ_id) {
      this.dialogTableVisible=true;
      axios.get('/otherApi/manager/gethisotryshow/', {
        params: {
          equ_id: equ_id,
        }
      }).then(res => {
        console.log("历史数据的", res);
        const data =(res.data.data); // 提取返回数据的对象
        this.gridData = data.times.map((times, index) => ({
          times: times,
          realtime_es: data.realtime_es[index] || '',
          meter_real_reding: data.meter_real_reding[index] || '',
          vfd_runtime: data.vfd_runtime[index] || '',
          cumulative_power_savings: data.cumulative_power_savings[index] || '',
        }));
        console.log(this.gridData)
      }).catch(error => {
        console.error('Error fetching history data:', error);
      });
    },
    //更新详细参数页面
    deviceInformation(equ_id, event) {
      // 阻止事件冒泡
      event.stopPropagation();

      // 初始化定时器存储
      this.pollingTimers = this.pollingTimers || {};

      // 清除所有定时器
      for (const key in this.pollingTimers) {
        if (this.pollingTimers[key]) {
          clearInterval(this.pollingTimers[key]);
          console.log(`清除定时器：设备ID ${key}`);
        }
      }

      // 设置新的定时器
      const shortPoll = () => {
        console.log(`开始轮询：设备ID ${equ_id}`);
        axios.get('/otherApi/manager/getonecompanysensor/', {
          params: { equ_id },
        })
          .then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
              this.updateFormData(res.data.data[0]);
            } else {
              console.error('No data returned or data is empty.');
            }
          })
          .catch((error) => {
            console.error('Error fetching equ id during polling:', error);
          });
      };

      this.pollingTimers[equ_id] = setInterval(shortPoll, 15000); // 每5秒轮询
      console.log(`设置新的定时器：设备ID ${equ_id}`);

      // 初始触发一次
      shortPoll();

      // 打开对话框
      this.$set(this.dialogFormVisible, equ_id, true);
    },
    updateFormData(data) {
      // 更新表单数据
      this.form.pre_mod_power_con = data.pre_mod_power_con;
      this.form.post_mod_power_con = data.post_mod_power_con;
      this.form.cumulative_power_savings = data.cumulative_power_savings;
      this.form.realtime_power_sr = data.realtime_power_sr;
      this.form.highest_daily_power_sr = data.highest_daily_power_sr;
      this.form.average_daily_power_sr = data.average_daily_power_sr;
      this.form.es_cumulative_runtime = data.es_cumulative_runtime;
      this.form.non_es_cumulative_power_con = data.non_es_cumulative_power_con;
      this.form.non_es_cumulative_duration = data.non_es_cumulative_duration;
      this.form.meter_number = data.meter_number;
      this.form.meter_reading = data.meter_reading;
      this.form.realtime_frequency = data.realtime_frequency;
    },
    // 控制修改频率的方法(目前只能控制大生纺织的变频器4号设备)
    sure(equ_id){
      console.log('控制修改频率的id是'+equ_id)
      axios.get('/otherApi/pub/', {
        params:{
          equ_id : equ_id, //设备id
          update_f : this.form.update_f //频率参数
        }
      }).then(res => {
        console.log(res)
        if (res.data.code === 200){
          this.$message.success("修改成功!")
          console.log("指令下发成功!")
          this.form.update_f = '';
          this.dialogFormVisible[equ_id]=false;
        }else {
          this.$message.error("修改失败!")
          console.log("指令下发失败!")
        }
      }).catch(error =>{
        console.error("请求失败:",error);
      });
    },
    // 查看耗电曲线
    async showCard(equ_id){
      this.dialogFormVisible = false;
      this.dialogVisible = true;
      try {
        const res = await axios.get('/otherApi/manager/getesshow/', {
          params: { equ_id: equ_id }
        });
        this.option.xAxis.data = res.data.data.times.reverse();
        this.option.series[0].data = res.data.data.p_now.reverse();
        let pRealArray = new Array(48).fill(res.data.data.p_real);
        this.option.series[1].data = pRealArray;
        // 确保数据准备好后再初始化 echarts
        if (res.data.data.times.length > 0 && res.data.data.p_now.length > 0 && res.data.data.p_real) {
          this.initEcharts();
        } else {
          console.error('Data is empty or incomplete.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    //初始化耗电曲线
    initEcharts() {
      try {
        let lineDom = document.getElementById("line");
        let lineChart = echarts.init(lineDom);
        lineChart.setOption(this.option);
      } catch (error) {
        console.error('Error initializing echarts:', error);
      }
    },
    // 启动按钮
    open(equ_id){
      axios.get('/otherApi/ifstart/', {
        params:{
          equ_id : equ_id, //设备id
        }
      }).then(res =>{
        if (res.data.code === 200){
          this.$message.success("设备已启动!");
        }else {
          this.$message.error("启动失败!");
        }
      }).catch(error =>{
        console.error("请求失败:",error);
      });
    },
    // 关闭按钮
    close(equ_id){
      axios.get('/otherApi/ifstop/', {
        params:{
          equ_id : equ_id, //设备id
        }
      }).then(res =>{
        if (res.data.code === 200){
          this.$message.success("设备已停止!");
        }else {
          this.$message.error("关闭失败!");
        }
      }).catch(error =>{
        console.error("请求失败:",error);
      });
    },
    //根据设备id 去 查找企业下的所有设备
    updateDeviceData(equ_id) {
      axios.get('/otherApi/manager/getonecompanysensor/', {
        params: { equ_id }
      }).then(res => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          // 更新设备信息
          const deviceData = res.data.data[0];
          const deviceIndex = this.devices.findIndex(device => device.equ_id === equ_id);
          //console.log("a a a a " + deviceIndex)
          if (deviceIndex !== -1) {
            this.$set(this.devices, deviceIndex, {
              equ_id,
              equ_name: deviceData.equ_name || 'N/A',
              pre_mod_power_con: deviceData.pre_mod_power_con || 'N/A',
              post_mod_power_con: deviceData.post_mod_power_con || 'N/A',
              cumulative_power_savings: deviceData.cumulative_power_savings || 'N/A',
              realtime_power_sr: deviceData.realtime_power_sr || 'N/A',
              highest_daily_power_sr: deviceData.highest_daily_power_sr || 'N/A',
              average_daily_power_sr: deviceData.average_daily_power_sr || 'N/A'
            });
          }
        } else {
          console.error('No data returned or data is empty.');
        }
      }).catch(error => {
        console.error('Error fetching device data:', error);
      });
    },
    initializeData() {
      this.devices = []; // 初始化 this.devices 数组
      this.dialogFormVisible = {}; // 初始化 dialogFormVisible 对象
      this.timers = {};

      // 在 created 钩子中为每个设备ID初始化一个布尔值状态
      this.devices.forEach(device => {
        this.$set(this.dialogFormVisible, device.equ_id, false);
        this.updateDeviceData(device.equ_id);
      });
    }
  },
  created() {
    // 1. 初始化
    this.initializeData();
    // 2. 获取查询参数中的company_id
    const company_id = this.$route.query.company_id;
    console.log('Company ID:', company_id);  // 确认已获取到company_id
    if (!company_id) {
      console.error('Company ID is missing');  // 如果没有company_id，输出错误
      return;
    }


    // 3. 根据company_id查找所有设备信息
    axios.get('/otherApi/manager/getallcompanysensor/', {
      params: {
        company_id: company_id,  // 传递company_id
      },
    })
      .then((response) => {
        const deviceDataArr = response.data.data;  // 获取返回的设备数据
        console.log("我想把这个deviceDataArr的值打印出来"+JSON.stringify(deviceDataArr));
        // 4. 将设备信息存储到devices中
        deviceDataArr.forEach((deviceData) => {
          this.devices.push({
            equ_id: deviceData.equ_id || 'N/A',
            equ_name: deviceData.equ_name || 'N/A',
            pre_mod_power_con: deviceData.pre_mod_power_con || 'N/A',
            post_mod_power_con: deviceData.post_mod_power_con || 'N/A',
            cumulative_power_savings: deviceData.cumulative_power_savings || 'N/A',
            realtime_power_sr: deviceData.realtime_power_sr || 'N/A',
            highest_daily_power_sr: deviceData.highest_daily_power_sr || 'N/A',
            average_daily_power_sr: deviceData.average_daily_power_sr || 'N/A',
          });
        });

        // 5. 定时更新设备信息
        this.devices.forEach((device) => {
          const timerId = setInterval(() => {
            this.updateDeviceData(device.equ_id);  // 每5秒钟更新一次设备信息
          }, 15000);
          this.$set(this.timers, device.equ_id, timerId);  // 存储定时器ID
        });
      })
      .catch((error) => {
        console.error('Error fetching device data:', error);  // 捕获错误
      });
  },
}
</script>

<style scoped>
.ktt{
  background-image: url("../assets/img/img_12.png");
  background-size: 160px;
  width: 160px;
  height: 130px;
  background-repeat: no-repeat;
  position: absolute;
  top: 20px;
}
#acu-button{
  width: 80px;
  height: 80px;
  opacity: 0;
  margin-left: -8px;
  margin-top: -5px;
}
.acu{
  background-image: url("../assets/img/img_9.png");
  background-size: 160px;
  width: 160px;
  height: 160px;
  background-repeat: no-repeat;
  position: absolute;
  top: 30px;
}
.acuu{
  background-image: url("../assets/img/img_13.png");
  background-size: 160px;
  width: 160px;
  height: 130px;
  background-repeat: no-repeat;
  position: absolute;
  top: 20px;
}
.d-input{
  width: 280px;
}
.custom-dialog-title {
  color: rgba(16,163,127,0.7); /* 修改标题颜色 */
  font-size: 18px; /* 修改标题大小 */
}
.kt{
  background-image: url("../assets/img/img_11.png");
  background-size: 160px;
  width: 160px;
  height: 160px;
  background-repeat: no-repeat;
  position: absolute;
  top: 20px;
}
.kt1{
background-image: url("../assets/img/img_11.png");
  background-size: 160px;
  width: 160px;
  height: 160px;
  background-repeat: no-repeat;
  position: absolute;
  top: 2px;
  left: 70px;
}
.kt2{
background-image: url("../assets/img/img_11.png");
  background-size: 160px;
  width: 160px;
  height: 160px;
  background-repeat: no-repeat;
  position: absolute;
  top: 2px;
  left: 70px;
}
#kt-button{
  width: 120px;
  height: 120px;
  opacity: 0;
  margin-left: -8px;
  margin-top: -5px;
}
.a{
  font-size: 11px;
  width: 140px;
  background-color: rgba(236,245,255);
  position: absolute;
  top: -37px;
  left: 1px;
}
.b{
  font-size: 11px;
  width: 140px;
  background-color: rgba(236,245,255);
  position: absolute;
  left: -9px;
  top: 2px;
}
.c{
  font-size: 11px;
  width: 140px;
  position:absolute;
  top: 40px;
  left: -9px;
  background-color: rgba(236,245,255);
}
.d{
  font-size: 11px;
  width: 155px;
  position: absolute;
  top: -37px;
  left: 134px;
  background-color: rgba(236,245,255);
}
.e{
  font-size: 11px;
  width: 155px;
  position: absolute;
  left: 134px;
  top: 2px;
  background-color: rgba(236,245,255);
}
.f{
  font-size: 11px;
  width: 155px;
  position: absolute;
  top: 40px;
  left: 134px;
  background-color: rgba(236,245,255);
}
.small-label label {
  font-size: 12px; /* 或者你想要的任何字体大小 */
}
.el-card {
  cursor: pointer;
  position: relative; /* 将卡片的定位改为相对定位 */
  top: 60px;
  left: -63px;
  margin: 40px; /* 添加外边距以增加卡片之间的间距 */
  width: 300px; /* 设置卡片的宽度 */
  height: 310px; /* 设置卡片的高度 */
  border: 1px solid gainsboro; /* 添加边框样式 */
}
.buttonC {
  height: 60px;
  display: flex; /* 将按钮容器设为 Flex 容器 */
  justify-content: space-around; /* 均匀分布按钮 */
  align-items: center; /* 垂直居中对齐按钮 */
  position: relative; /* 将按钮容器的定位改为绝对定位 */
  top: 102px;
  bottom: 10px; /* 与卡片底部的距离 */
  left: -112px; /* 与卡片左侧对齐 */
  width: 100%; /* 撑满卡片宽度 */
}
.buttonC .el-button {
  font-size: 11px; /* 按钮字体大小 */
  width: 150px; /* 按钮宽度 */
}
#all {
  position: relative; /* 将按钮文本定位改为相对定位 */
  left: -15px; /* 调整文本位置 */
}
.chart-container {
  width: 100%; /* 设置图表容器宽度为100% */
  height: 280px; /* 调整图表容器高度 */
}
/*---------------------------------------------------------------------------调整卡片*/
.card-container {
  display: flex; /* 将容器设为 Flex 容器 */
  flex-wrap: wrap; /* 设置自动换行 */
  justify-content: flex-start; /* 靠左对齐 */
  align-items: center; /* 垂直居中对齐 */
  width: 1200px;
  position: absolute;
  left: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/TestCard.vue